const translations = {
    fieldBoundaries: 'Field Boundaries',
    otherFieldBoundaries: 'Other Field Boundaries',
    unassignedBoundaries: 'Unassigned Boundaries'
};

export default translations;
